import React, { useState } from "react";
import { CircularProgress } from "@mui/material";

const LazyImage = (props) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const { src, alt, className } = props;

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div>
      {!imageLoaded && (
        <div
          className="loader"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <CircularProgress />
        </div>
      )}

      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        style={{ display: imageLoaded ? "block" : "none" }}
        className={className}
      />
    </div>
  );
};

export default LazyImage;
